<template><BusinessPage module-key="students" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'StudentsPage', components: { BusinessPage } }</script>
